import Flickity from "flickity";

export default class LoyaltySlideshow {
  constructor() {
    const $els = document.querySelectorAll('.js-loyalty-slideshow-slider');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;

    this.carousel = new Flickity(this.$el, {
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      imagesLoaded: true,
      draggable: false
    });
  }
}
